export default {
	accountSidebar: {
		links: {
			bidsAndOffers: {
				active: 'Active',
				didntWin: "Didn't win",
				underOffer: 'Under offer',
			},
			purchases: {
				cancelled: 'Cancelled',
				complete: 'Complete',
			},
		},
		titles: {
			bidsAndOffers: 'Bids & offers',
			purchases: 'Purchases',
		},
	},
};
